module.exports = __webpack_public_path__ + "img/r201.dc5ae06a.png";